import { and, eq } from "truth-helpers";
import WazeWikiPostHeader from "../../components/waze-wiki-post-header";

<template>
  {{#if (and @outletArgs.post.wiki (eq @outletArgs.post.post_number 1))}}
    <WazeWikiPostHeader @post={{@outletArgs.post}} />
  {{else}}
    {{yield}}
  {{/if}}
</template>
